import React, { useEffect, useState } from 'react'
import { Link } from 'react-router-dom';
import style from "./style.module.css";
import { getStorage } from '../../modals/Storage';

function View() {
    const [categories, setCategories] = useState([]);

    useEffect(() => {
        const stored = getStorage("categories");
        if (stored) {
            setCategories(JSON.parse(stored));
        }
    }, []);

    if (!categories || categories.length === 0) {
        return null;
    }

    return (
        <div className={style.parentView}>
            {categories.map((data, index) => (
                <Link className={style.item} key={`category_${index}`}
                    to={{
                        pathname: "/search",
                        search: `?q=${encodeURIComponent(data["item_id"])}&d=${encodeURIComponent(data["item_name"])}&linked=true`
                    }}>
                    <span className="material-symbols-outlined icon-size-sm mg-r-5">{data.item_icon}</span>
                    {data.item_name}
                </Link>
            ))}
        </div>
    );
}

export default View;